// extracted by mini-css-extract-plugin
export default {"inputDate":"InputDate_inputDate__MehFD"};